import { DASHBOARD_DATA_KEYS } from 'constants/dashboard';
import { colors } from 'muiTheme/palette';

const getPerformanceColor = (performanceValue) => {
  if (performanceValue === 0) {
    return colors.lightGrey;
  }

  if (performanceValue <= 50) {
    return colors.statusRed;
  }

  if (performanceValue <= 60) {
    return colors.statusOrange;
  }

  if (performanceValue < 80) {
    return colors.statusYellow;
  }

  return colors.statusGreen;
};

const getGrowingColor = (growingValue) => {
  if (growingValue >= 5) {
    return colors.statusGreen;
  }

  if (growingValue <= -5) {
    return colors.statusRed;
  }

  return colors.statusYellow;
};

const getParticipationColor = (participationValue) => {
  if (participationValue === 0) {
    return colors.lightGrey;
  }

  if (participationValue < 50) {
    return colors.statusRed;
  }

  if (participationValue < 70) {
    return colors.statusYellow;
  }

  return colors.statusGreen;
};

export const getDashboardColors = (dataKey, value) => {
  const numberValue = Number(value);

  switch (dataKey) {
    case DASHBOARD_DATA_KEYS.PERFORMANCE:
      return getPerformanceColor(numberValue);
    case DASHBOARD_DATA_KEYS.GROWING:
      return getGrowingColor(numberValue);
    case DASHBOARD_DATA_KEYS.PARTICIPATION:
      return getParticipationColor(numberValue);
    default:
      return '';
  }
};

export const getHeatmapColors = (value) => {
  const numberValue = Number(value);

  if (numberValue <= 3.5) {
    return colors.statusRed;
  }

  if (numberValue <= 4.2) {
    return colors.statusOrange;
  }

  if (numberValue < 5.6) {
    return colors.statusYellow;
  }

  return colors.statusGreen;
};

export const setColorGrowing = (val) => {
  const num = Number(val);

  if (num >= 5) {
    return 'success';
  }

  if (num <= -5) {
    return 'danger';
  }

  return 'warning';
};
